// extracted by mini-css-extract-plugin
export default {"VehicleSettingsBox":"S6FYe","VehicleSettingsBoxContent":"H1Nyr","critAirLine":"xKdAP"};